import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac89e3d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "my-card--body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShowing)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "my-modal--background",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close-modal')))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["my-card my-modal--modal", _ctx.classes]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            class: "close-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-modal')))
          }, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}